import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { MOBILE_BREAKPOINT } from '../../../../../submission-details-view.constants';

export const syncButtonStyle = css`
  svg {
    flex-shrink: 0;
  }

  @container submission-details-view (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: ${theme.spacing(0.5, 1)};
    height: auto;
    align-self: center;
  }
`;
